<template>
    <!--我的订阅-->
    <div class="my_auction">
        <div class="content_box">
            <div class="content_item" v-for="item in list" :key="item.id">
                <div class="item_top">
                    <!--<div class="lead"-->
                    <!--v-show="new Date(item.time_end).getTime() > nowTime && item.price === item.price_cur">-->
                    <!--领先-->
                    <!--</div>-->
                    <!--<div class="backward"-->
                    <!--v-show="new Date(item.time_end).getTime() > nowTime && item.price < item.price_cur">-->
                    <!--落后-->
                    <!--</div>-->
                    <div class="content_left" @click="toDetail(item)">
                        <img class="content_img" :src="item.goods_logo" alt="">
                    </div>
                    <div class="content_right" @click="toDetail(item)">
                        <div class="name">
                            {{ item.goods_name}}
                        </div>
                        <div class="price_time">
                            开拍时间：<span class="price">
                            {{ item.time_start }}
                        </span>
                        </div>
                        <div class="price_time">
                            结束时间：<span class="price">
                            {{ item.time_end }}
                        </span>
                        </div>
                    </div>
                    <div @click="noticChg(item)" class="deleteNotice">
                        取消订阅
                    </div>
                </div>
            </div>
            <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-size="limit"
                    layout="total, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	import {me_notice,notice_chg} from "../../apiNew/index";

	export default {
		data() {
			return {
				page: 1,
				limit: 10,
				total: 0,
				list: [],
			};
		},
		components: {},
		created() {
		},
		methods: {
			// 取消订阅
			noticChg(item) {
				notice_chg({
					goods_id: item.id,
					token: localStorage.getItem('token')
				}).then(res => {
					// console.log(res)
					this.$notify({
						title: res.message,
						type: 'success'
					});
					this.checkNotice()
				}).catch(error => {
					this.$notify({
						message: error.message,
						type: "error"
					});
					if (error.code === -101) {
						this.$router.push({name: 'login'})
					}
				})
			},
			init() {
				me_notice({
					page: this.page,
					limit: this.limit,
					token: localStorage.getItem('token')
				}).then(res => {
					// console.log(res)
					this.list = res.data.data
					this.total = res.data.total
				}).catch(error => {
					if (error.code === -101) {
						this.$router.push("/login");
					} else {
						console.log(error)
					}
				})
			},
			toDetail(item) {
				// localStorage.setItem('auctionId', id)
				// this.$router.push({name: 'auctionDetail'})
				this.$router.push({name: 'auctionDetail', params: {id: item.goods_id, type: item.is_type}})
			},
			handleCurrentChange(val) {
				this.page = val
				this.init()
			},

		},
		mounted() {
			this.init()
		},
	}

</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import 'myAuction';
</style>
